import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TestimonialContainerConverter extends CmsConverterService<TestimonialContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      testimonials: formData.st_testimonial ?? defaultFSCatalog
    } as TestimonialContainerData
  }
}

export const TESTIMONIAL_CONTAINER_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, TestimonialContainerData>>('TestimonialContainerConverter')

export interface TestimonialContainerData extends ConvertedComponentData {
  testimonials: FsCatalog;
}
